import React from "react";
import Avatar from "../../ui/Avatar";

const MyIcon = ({ myAttr }) => {
  return (
    <div
      className={`effice-icon ${
        myAttr.avatar_key ? "invisible-background" : null
      }`}
    >
      <Avatar
        avatar_key={myAttr.avatar_key}
        given_name={myAttr.given_name}
        family_name={myAttr.family_name}
      />
    </div>
  );
};

export default MyIcon;
